import { render, staticRenderFns } from "./ImageCardNew.vue?vue&type=template&id=709b2a38"
import script from "./ImageCardNew.vue?vue&type=script&lang=js"
export * from "./ImageCardNew.vue?vue&type=script&lang=js"
import style0 from "./ImageCardNew.vue?vue&type=style&index=0&id=709b2a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports